module.exports = "/_next/static/images/MakeDataDrivenDecisions-bf2485756d3a6b84b859ef3572de2850.webp";